import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { useDispatch } from 'react-redux'

const ShowEditingAction = notificationActionCreators.setNotification({
  type: NotificationType.SYMBOL_EDITING,
})

const HideEditingAction = notificationActionCreators.setClearNotification({
  toastContainerId: 'main',
})

export const useBlockFocus = () => {
  const dispatch = useDispatch()

  const onFocus = () => {
    dispatch(ShowEditingAction)
  }

  const onBlur = () => {
    dispatch(HideEditingAction)
  }

  return { onBlur, onFocus }
}
